<template>
  <div class="unc-CellName">
    <AppAvatar :avatar-url="item[avatarUrlKey]" no-margins />

    <AppLink
      v-if="resolvedNameAsLink"
      :to="`${ROUTE_PATHS.WORKSPACES}${ROUTE_PATHS.SETTINGS}/${ROUTE_PATHS.ORGANIZATION}/${item[accountIdKey]}`"
    >
      <template #default="{ href, onClick }">
        <AppLinkResolver
          :href="href"
          class="unc-Name unc-Name_Link"
          hover-underline
          @click.prevent="onClick"
        >
          {{ item[itemLabel] }}
        </AppLinkResolver>
      </template>
    </AppLink>
    <span v-else class="unc-Name">
      {{ item[itemLabel] }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { ROUTE_PATHS } from '@/routes/route-helpers'

import AppAvatar from '@/components/ui/AppAvatar/AppAvatar'
import AppLink from '@/components/ui/AppLink/AppLink'
import AppLinkResolver from '@/components/ui/AppLink/AppLinkResolver'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },

  nameAsLink: {
    type: Boolean
  },

  itemLabel: {
    type: String,
    default: 'displayName'
  },

  avatarUrlKey: {
    type: String,
    default: 'avatarUrl'
  },

  accountIdKey: {
    type: String,
    default: 'accountId'
  }
})

defineOptions({
  name: 'UserNameCell'
})
const store = useStore()

const hasAccessToGlobalGroupsPage = computed(
  () => store.state.system.userData.hasAccessToGlobalGroupsPage
)

const router = useRouter()

const resolvedNameAsLink = computed(() => {
  if (!router) {
    return false
  }

  return hasAccessToGlobalGroupsPage.value && props.nameAsLink
})
</script>

<style lang="scss" scoped>
.unc-CellName {
  display: flex;
  align-items: center;
  padding-right: var(--unc-padding-right, 4px);
  gap: 4px;
  max-width: 100%;
  overflow: hidden;
}
.unc-Name {
  margin-left: 4px;
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('semi-bold');
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  --unc-name-color: inherit;
  color: var(--unc-name-color);
  &_Link {
    --unc-name-color: #{$primary-color-next};
  }
}
</style>
